var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6815 2H5.68146C4.68146 2 3.86328 2.81818 3.86328 3.81818V15.6364C3.86328 16.1364 4.27237 16.5455 4.77237 16.5455C5.27237 16.5455 5.68146 16.1364 5.68146 15.6364V4.72727C5.68146 4.22727 6.09055 3.81818 6.59055 3.81818H15.6815C16.1815 3.81818 16.5906 3.40909 16.5906 2.90909C16.5906 2.40909 16.1815 2 15.6815 2ZM16.2179 6.17272L20.6088 10.5636C20.9452 10.9 21.1361 11.3636 21.1361 11.8454V20.1818C21.1361 21.1818 20.3179 22 19.3179 22H9.30879C8.30879 22 7.4997 21.1818 7.4997 20.1818L7.50879 7.45454C7.50879 6.45454 8.31788 5.63636 9.31788 5.63636H14.927C15.4088 5.63636 15.8724 5.82727 16.2179 6.17272ZM19.7724 12H15.6815C15.1815 12 14.7724 11.5909 14.7724 11.0909V7L19.7724 12Z",
    fill: "#7477B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4e981e27.svg";
export { ForwardRef as ReactComponent };